import ProjectsListItem from './ProjectsListItem';

// @vue/component
export default {
  name: 'ProjectsList',

  components: {
    ProjectsListItem,
  },

  computed: {
    projectsList() {
      return this.$store.getters['client/projects/list'];
    },
  },

  created() {
    this.$store.dispatch('client/projects/getList');
  },

  methods: {
    handleChangePage(page) {
      this.$store.dispatch('client/projects/changePage', page);
    },
  },
};
